import getParsedLink from "@utils/get-parsed-link";
import getUtmsAndAdditionalData from "~/src/utils/get-utms-and-additional-data";
import keysToSnake from "~/src/utils/keys-to-snake";
import objFromUrlParam from "~/src/utils/obj-from-url-param";

const Types = {
  SET_CATALOG: "SET_CATALOG",
  SET_CURRENT_PLAN: "SET_CURRENT_PLAN",
  SET_ELEGIBILIDADES: "SET_ELEGIBILIDADES",
  SET_TECNOLOGIA: "SET_TECNOLOGIA",
  CLEAR_DATA: "CLEAR_DATA",
};

const defaultState = {
  portfolio: {},
  selectedPlan: {},
  elegibilidades: {
    cartao: true,
    boleto: true,
  },
  tecnologia: "",
};

export const state = { ...defaultState };

export const getters = {
  segmento: state => {
    const {
      selectedPlan: {
        info_plano: { tipo_fatura },
      },
    } = state;
    if (tipo_fatura.toLowerCase() === "digital") {
      return "boleto";
    } else {
      return tipo_fatura.replace("ã", "a").toLowerCase() || "cartao";
    }
  },
  getAppsName: state => [
    ...state.selectedPlan.info_plano.apps.imagens.map(item =>
      item.replace(".svg", "")
    ),
    ...(
      state.selectedPlan.info_plano.apps_add || { imagens: [] }
    ).imagens.map(item => item.replace(".svg", "")),
  ],
  tipoPlano: state =>
    state.selectedPlan.info_plano.tipo_plano.toLowerCase() || "controle",
  subTipoPlano: state =>
    state.selectedPlan.info_plano.sub_tipo_plano.toLowerCase() || "",
  getCategory: (_, getters) =>
    `movel/plano/${getters.tipoPlano + getters.subTipoPlano}`,
  getSelectedPlan: state => state.selectedPlan,
  isAnualPlan: state =>
    state.selectedPlan.info_plano.anual.toLowerCase() === "true",
  getPaymentText: state => state.selectedPlan.info_plano.texto_pagamento,
  getSku: state => state.selectedPlan.sku,
  getPrice: state => state.selectedPlan.valores_plano.valor_com_desconto,
  getOriginalPrice: state => state.selectedPlan.valores_plano.valor_oferta,
  getPlanName: state => state.selectedPlan.info_plano.plano,
  getContract: state => state.selectedPlan.info_plano.url_contrato,
  getPlanData: state =>
    state.portfolio.controle.map(item => {
      return {
        type:
          item.info_plano.tipo_fatura.toLowerCase() === "digital"
            ? "boleto"
            : "cartao",
        size: item.info_plano.dados,
        sku: item.sku,
      };
    }),
  getElegibilidades: state => state.elegibilidades,
  produto: state => ({
    produto: state.selectedPlan.info_plano.produto,
    sku: state.selectedPlan.sku,
    anual: state.selectedPlan.info_plano.anual.toLowerCase() === "true",
  }),
  getDependentesRules: state => state.selectedPlan.info_plano.dependentes,
  getAllPlans: state => [
    ...(state.portfolio.controle || []),
    ...(state.portfolio.pos || []),
    ...(state.portfolio.fixa || []),
  ],
  banner: (state, getters, rootState) => ({
    ...state.selectedPlan.info_plano.banner.filter(
      item => item.projeto === rootState.query.company
    )[0],
  }),
  bannerLink: (state, getters, rootState, rootGetters) => {
    const bannerUrl = state.selectedPlan.info_plano.banner.link;
    if (!bannerUrl) return "";
    const rootUtms = getUtmsAndAdditionalData(
      keysToSnake(rootGetters.getQuery),
      false
    );
    const bannerUtms = getUtmsAndAdditionalData(
      objFromUrlParam(bannerUrl),
      false
    );

    return getParsedLink(bannerUtms, rootUtms, bannerUrl);
  },
  getTecnologia: state => state.tecnologia,
  getDigitalPlans: state =>
    [
      ...(state.portfolio.controle || []),
      ...(state.portfolio.pos || []),
      ...(state.portfolio.fixa || []),
    ].filter(plan => plan.info_plano.tipo_fatura === "Digital"),
  getDescriptionBonusBannerContaDigital: state =>
    state.selectedPlan.info_plano.ofertas_promocoes[0].descricao,
  getBadgeTextBtnDebitoAutomatico: state =>
    state.selectedPlan.info_plano.ofertas_promocoes[1].descricao,
  getTooltipTextDebitoAutomatico: state =>
    state.selectedPlan.info_plano.ofertas_promocoes[2].descricao,
  getBannerPopup: state => state.selectedPlan.info_plano.abandono,
};

export const mutations = {
  [Types.SET_CATALOG]: (state, portfolio) => (state.portfolio = portfolio),
  [Types.SET_CURRENT_PLAN]: (state, selectedPlan) =>
    (state.selectedPlan = selectedPlan),
  [Types.SET_ELEGIBILIDADES]: (state, elegibilidades) =>
    (state.elegibilidades = elegibilidades),
  [Types.SET_TECNOLOGIA]: (state, tecnologia) =>
    (state.tecnologia = tecnologia),
  [Types.CLEAR_DATA]: state => {
    state.portfolio = {};
    state.selectedPlan = {};
    state.tecnologia = "";
  },
};

export const actions = {
  clearData: ({ commit }) => commit(Types.CLEAR_DATA),
  setCatalog({ commit }, catalog) {
    commit(Types.SET_CATALOG, catalog.portfolio);
  },
  setSelectedPlan({ commit, getters }, sku) {
    const selectedPlan = getters.getAllPlans.filter(plan => plan.sku === sku);

    const selectedPlanDefault = getters.getAllPlans.filter(
      plan => plan.sku === "CTRL001DN"
    );

    // const selectedPlanDefault = getters.getAllPlans[0];

    if (selectedPlan.length) {
      commit(Types.SET_CURRENT_PLAN, selectedPlan[0]);
    } else {
      commit(Types.SET_CURRENT_PLAN, selectedPlanDefault[0]);
    }
    return getters;
  },

  setSelectedPlanBySvc({ commit, getters }, svc) {
    const selectedPlan = getters.getAllPlans.filter(
      plan => plan.info_plano.campanha === svc
    );

    const selectedPlanDefault = getters.getAllPlans.filter(
      plan => plan.info_plano.campanha === "PLSMT16GB2016CF"
    );

    if (selectedPlan.length) {
      commit(Types.SET_CURRENT_PLAN, selectedPlan[0]);
    } else {
      commit(Types.SET_CURRENT_PLAN, selectedPlanDefault[0]);
    }
    return getters;
  },
  setElegibilidades(
    { commit },
    elegibilidades = { cartao: true, boleto: true }
  ) {
    commit(Types.SET_ELEGIBILIDADES, elegibilidades);
  },
  setTecnologia({ commit }, tecnologia) {
    commit(Types.SET_TECNOLOGIA, tecnologia);
  },
};
